/* eslint-disable import/no-extraneous-dependencies */
import { Component, inject, input } from "@angular/core";
import { ICorrListItem } from "@api";
import { ITimelineItem } from "@bbj/components";
import CorrespondenceStatus from "@models/CorrespondenceStatus";
import ManagerResponseDetailItem from "@models/managerResponseDetailItem";
import ResponseDetailItem from "@models/responseDetailItem";
import LocalContractUserService from "@services/local-contractUser.service";
import { getLastestIssuedItem } from "@shared/utils";

@Component({
  selector: "corrProcessing",
  templateUrl: "./corrProcessing.component.html",
  styleUrls: ["./corrProcessing.component.scss"],
  standalone: false
})
export default class CorrProcessingComponent {
  localContractUserService = inject(LocalContractUserService);

  readonly corr = input<ICorrListItem>(undefined);

  timelineItems: ITimelineItem[];

  responseDetail: ResponseDetailItem;

  managerResponseDetail: ManagerResponseDetailItem;

  title: string;

  ngOnInit(): void {
    const corr = this.corr();
    if(corr.correspondence_flow && corr.correspondence_flow.length > 0)
    {
      this.timelineItems = corr.correspondence_flow
        .filter((f)=>f.Status !== CorrespondenceStatus.Draft)
        .sort((a, b) => new Date(a.DateReceived).getTime() - new Date(b.DateReceived).getTime())
        .map((item, i) => {
          const timeSubmitted = item.DateReceived ? this.getFormatedDateAndTime(item.DateReceived) : "N/A";
          const daysInBic = "N/A";
          let initBic = 'Doc Control';
          if(item.BICUserId)
          {
            const initUser = this.localContractUserService.getUserInfo(item.BICUserId);
            const initUserrole = this.localContractUserService.getUserRole(item.BICUserId);
            initBic = `${initUser?.displayName ?? ""} (${initUserrole ?? ""})`;
          }
          
          const submittedUser = this.localContractUserService.getUserInfo(item.SubmittedBy);
          const submittedUserRole = this.localContractUserService.getUserRole(item.SubmittedBy);
          const submittedBy = `${submittedUser?.displayName ?? ""} (${submittedUserRole ?? ""})`;
          const status = i === 0 ? "Submitted" : item.Status;
          return { sequence: i + 1, status, bic: initBic, timeSubmitted, daysInBic, submittedBy: submittedBy }
        });
    }
    if(corr.correspondence_issued.length > 0)
    {
      const lastIssued = getLastestIssuedItem(corr);
      this.responseDetail = new ResponseDetailItem(lastIssued, this.localContractUserService);
      if(corr.correspondence_response && corr.correspondence_response.length > 0) {
        this.managerResponseDetail = new ManagerResponseDetailItem(lastIssued?.ManagerId, corr.correspondence_response[0], this.localContractUserService);
      }
    }
    
    this.title = corr.Status === CorrespondenceStatus.Filed ? "Notes" : "Response Requested";
  }

  private getFormatedDateAndTime(date: string): string {
    return `${new Date(date)
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      })
      .replace(", ", "/")
      .replace(" ", "/")} ${new Date(date).toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    })}`;
  }

}
